/**
 * Content layout
 * @author Carlos Romera <cromera@adasasistemas.com>
 */
import { LayoutProps } from '@types';

import styles from './contentLayout.module.scss';

export const ContentLayout: LayoutProps = ({ children }) => {
	return <div className={styles.wrapper}>{children}</div>;
};

export default ContentLayout;
